import qs from 'qs';

import axiosInstance from '../request';
import { pickDevParams } from '../../utils/config';

export const servicesCategories = () => axiosInstance.get('/services/list', { params: pickDevParams });

export const servicesProviders = () => axiosInstance.get('/services/providers', { params: pickDevParams });

export const servicesConfiguration = () => axiosInstance.get('/services/configuration', { params: pickDevParams });

export const servicesStartCounts = () => axiosInstance.get('/services/get-start-count', { params: pickDevParams });

export const servicesSubscriptionTypes = () => axiosInstance.get('/services/get-subscription-types', { params: pickDevParams });

export const servicesTypes = () => axiosInstance.get('/services/types', { params: pickDevParams });

export const servicesGetDescription = (id) => axiosInstance.get(`/services/get-description-form/${id}`, { params: pickDevParams });

export const servicesGetProviderDescription = (id) => axiosInstance.get(`/services/get-provider-description/${id}`, { params: pickDevParams });

export const servicesGetCategoryNames = (categoryId) => axiosInstance.get('/services/get-category-form/', { params: { categoryId, ...pickDevParams } });

export const servicesDuplicate = (id) => axiosInstance.post(`/services/duplicate/${id}`, qs.stringify(pickDevParams));

export const serviceServicesDelete = (id) => axiosInstance.post(`/services/delete/${id}`, qs.stringify(pickDevParams));

export const servicesDeleteCategory = (id) => axiosInstance.post(`/services/delete-category/${id}`, qs.stringify(pickDevParams));

export const servicesStatus = (id, status) => axiosInstance.post(`/services/change-status/${id}`, { status, ...pickDevParams });

export const servicesMassStatus = (payload) => axiosInstance.post('/services/mass-change-status', { ...payload, ...pickDevParams });

export const servicesVisibilityCategory = (id, status) => axiosInstance.post(`/services/change-status-category/${id}`, { status, ...pickDevParams });

export const servicesUpdateDescription = (id, description) => axiosInstance.post(`/services/change-description/${id}`, { description, ...pickDevParams });

export const servicesCreateCategory = (name, position, icon) => axiosInstance.post('/services/add-category', { name, position, icon, ...pickDevParams });

export const servicesUpdateCategory = (id, name, icon) => axiosInstance.post(`/services/edit-category/${id}`, { name, icon, ...pickDevParams });

export const servicesResetCustomRate = (id) => axiosInstance.post(`/services/reset-rates/${id}`, qs.stringify(pickDevParams));

export const serviceServicesMassDelete = (list) => axiosInstance.post('/services/mass-delete', { list, ...pickDevParams });

export const serviceServicesAssignCategory = (categoryId, list) => axiosInstance.post('/services/mass-change-category', { categoryId, list, ...pickDevParams });

export const serviceServicesMassResetCustomRate = (list) => axiosInstance.post('/services/mass-reset-rates', { list, ...pickDevParams });

export const serviceServicesChangePosition = (categoryId, list) => axiosInstance.post(`/services/change-position/${categoryId}`, { list, ...pickDevParams });

export const serviceServicesChangePositionCategory = (list) => axiosInstance.post('/services/change-category-position', { list, ...pickDevParams });

export const serviceServicesConvertRate = (list) => axiosInstance.post('/services/mass-convert-rates', { list, ...pickDevParams });

export const serviceServicesConvertRateCheck = (taskId) => axiosInstance.get(`/services/mass-convert-rates-check/${taskId}`, { params: pickDevParams });

export const serviceServicesGetImportServices = (providerId) => axiosInstance.get(`/services/get-import-list/${providerId}`, { params: pickDevParams });

export const serviceServicesGetServiceForm = (serviceId = null) => axiosInstance.get('/services/get-form-data', { params: { ...pickDevParams, serviceId } });

export const serviceServicesGetProviderForm = (providerId) => axiosInstance.get('/services/provider-form', { params: { ...pickDevParams, providerId } });

export const serviceServicesGetSyncRate = (providerId, rates) => axiosInstance.post('/services/get-sync-rate', { ...pickDevParams, providerId, rates });

export const serviceServicesAddService = (data) => axiosInstance.post('/services/add', { ...pickDevParams, ...data });

export const serviceServicesEditService = (data, serviceId) => axiosInstance.post(`/services/edit/${serviceId}`, { ...pickDevParams, ...data });

export const serviceServicesAddSubscription = (data) => axiosInstance.post('/services/subscription-add', { ...pickDevParams, ...data });

export const serviceServicesEditSubscription = (data, serviceId) => axiosInstance.post(`/services/subscription-edit/${serviceId}`, { ...pickDevParams, ...data });

export const serviceServicesImport = (providerId, categories, options) => axiosInstance.post(`/services/import/${providerId}`, { ...pickDevParams, categories, options });

export const serviceServicesImportCheck = (taskId) => axiosInstance.get(`/services/import-check/${taskId}`, { params: pickDevParams });

export const serviceServicesUploadImage = (file) => axiosInstance.post('/services/category-icon/upload', file, {
  headers: {
    'Content-Type': 'multipart/form-data',
  },
});

export const serviceMassEditRates = (services) => axiosInstance.post('/services/mass-edit-rates', { ...pickDevParams, services });

export const serviceGetAccessRates = (services) => axiosInstance.post('/services/mass-edit-rates-list', { ...pickDevParams, services });

export const servicesMassDripFeed = (drip_feed, list) => axiosInstance.post('/services/mass-drip-feed', { drip_feed, list, ...pickDevParams });

export const servicesDeletedList = (query) => axiosInstance.get('/services/deleted-list', { params: { ...pickDevParams, ...query } });
export const servicesDeletedMassRestore = (list) => axiosInstance.post('/services/mass-restore', { ...pickDevParams, list });
export const servicesDeletedRestore = (serviceId) => axiosInstance.post(`/services/restore/${serviceId}`, { ...pickDevParams });
export const servicesCategoryIcons = (query) => axiosInstance.get('/services/category-icons', { params: { ...pickDevParams, query } });
export const servicesHideList = (query) => axiosInstance.get('/services/hidden/list', { params: { ...pickDevParams, ...query } });
export const servicesHideHide = (query) => axiosInstance.post('/services/hidden/hide', { ...pickDevParams, query });
export const servicesHideRemove = (id) => axiosInstance.post(`/services/hidden/show/${id}`, { ...pickDevParams });

/* Hide categories */
export const servicesCategoriesHideList = (query) => axiosInstance.get('/services/hidden/categories/list', { params: { ...pickDevParams, ...query } });
export const servicesCategoriesHideHide = (categories) => axiosInstance.post('/services/hidden/categories/hide', { ...pickDevParams, categories });
export const servicesCategoriesHideRemove = (id) => axiosInstance.post(`/services/hidden/categories/show/${id}`, { ...pickDevParams });
export const servicesCountriesList = (query) => axiosInstance.get('/services/hidden/countries/list', { params: { ...pickDevParams, ...query } });
export const servicesCountriesUpdate = (countries) => axiosInstance.post('/services/hidden/countries/update', { ...pickDevParams, countries });
